<template>

	<div class="iconify-holder">
		<div class="block">
			<div class="iconify animated zoomIn" :key="iconClass">
				<i :class="iconClass"></i>
			</div>
		</div>
		<div class="block">
			<span class="animated fadeIn">
				<slot class="content" name="default">
					Información no disponible
				</slot>
			</span>
		</div>
	</div>

</template>
			
<script>
	export default {
		props: {
			iconClass: {
				type: String,
				default: 'fa fa-exclamation-circle'
			}
		}
	}
</script>
			
<style lang="less">
	.iconify-holder {
		padding: 1em;
		text-align: center;
		position: relative;
		BIG {
			font-size: 1.5rem;
			STRONG {
				font-size: inherit;
				font-weight: bolder;
			}
		}
		STRONG {
			font-size: inherit;
		}
		.iconify {
			display: inline-block;
			width: 100%;
			color: var(--primary);
			margin-bottom: 2em;
			
			svg {
				font-size: 5rem;
			}
		}
		SPAN {
			color: var(--primary);
			font-size: 1rem;
		}
	}
</style>